"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var transport_state_1 = require("./transport_state");
var Transport = /** @class */ (function () {
    // create everything
    function Transport() {
        this.getters = {
            'transport/getTransport': function (state) { return state; },
            'transport/getApiType': function (state) {
                switch (state.type) {
                    case 'flex': return 'AIR';
                    case 'flight': {
                        if (state.subType === 'flex') {
                            return 'FLX';
                        }
                        else {
                            return 'AIR';
                        }
                    }
                    case 'rail': return 'RIT';
                    default: return null;
                }
            },
            'transport/getOutgoing': function (state, getters) {
                if (state.type === 'flex' &&
                    getters['transportFlexFlights/displayOutgoingFlight']) {
                    return getters['transportFlexFlights/displayOutgoingFlight'].airportName;
                }
                if (state.type === 'flight' &&
                    getters['transportAir/displayOutgoingFlight']) {
                    return getters['transportAir/displayOutgoingFlight'].airportName;
                }
                if (state.type === 'flex' &&
                    getters['transportFlexFlights/displayOutgoingFlight']) {
                    return getters['transportFlexFlights/displayOutgoingFlight'].airportName;
                }
                if (state.type === 'rail')
                    return null; //{ return getters['transportRail/depStation'] }
                if (state.type === 'none' || state.type === '') {
                    return null;
                }
            },
            'transport/getReturning': function (state, getters) {
                if (state.type === 'flex' &&
                    getters['transportFlexFlights/displayReturningFlight']) {
                    return getters['transportFlexFlights/displayReturningFlight'].airportName;
                }
                if (state.type === 'flight' &&
                    getters['transportAir/displayReturningFlight']) {
                    return getters['transportAir/displayReturningFlight'].airportName;
                }
                if (state.type === 'flex' &&
                    getters['transportFlexFlights/displayReturningFlight']) {
                    return getters['transportFlexFlights/displayReturningFlight'].airportName;
                }
                if (state.type === 'rail')
                    return null; // { return getters['transportRail/arrStation'] }
                if (state.type === 'none' || state.type === '') {
                    return null;
                }
            },
            'transport/getTotalPrice': function (state, getters) {
                var totalPrice = 0;
                if (state.type === 'rail') {
                    return getters['transportRail/totalPrice'];
                }
                else if (state.type === 'flight') {
                    if (state.subType === 'flex') {
                        return getters['transportFlexFlights/totalPrice'] + getters['transportFlexFlights/rnfTotalPrice'];
                    }
                    return getters['transportAir/totalPrice'] + getters['transportAir/rnfTotalPrice'];
                }
                else if (state.type === 'flex') {
                    return getters['transportFlexFlights/totalPrice'] + getters['transportFlexFlights/rnfTotalPrice'];
                }
                return totalPrice;
            },
            'transport/getType': function (state) { return state.type; },
            'transport/getSubType': function (state) { return state.subType; },
            'transport/getValid': function (state, getters) {
                if (state.type === 'none')
                    return true;
                if (state.subType === 'flex' && getters['transportFlexFlights/valid'])
                    return true;
                if (state.subType === 'flex' && !getters['transportFlexFlights/valid'])
                    return false;
                if (state.type === 'flex' && getters['transportFlexFlights/valid'])
                    return true;
                if (state.type === 'flex' && !getters['transportFlexFlights/valid'])
                    return false;
                if (state.type === 'flight' && getters['transportAir/valid'])
                    return true;
                if (state.type === 'flight' && !getters['transportAir/valid'])
                    return false;
                if (state.type === 'rail')
                    return getters['transportRail/valid'];
                return getters['transport/getTotalPrice'] > 0;
            }
        };
        // available actions
        this.actions = {
            'transport/setSubType': function (_a, data) {
                var commit = _a.commit;
                commit('transport/SET_SUB_TYPE', data);
            },
            'transport/setType': function (_a, data) {
                var commit = _a.commit, dispatch = _a.dispatch, getters = _a.getters;
                commit('transport/SET_TYPE', data);
                if (data === 'none') {
                    commit('transport/SET_TRANSPORTATION', []);
                }
                if (data !== 'rail') {
                    dispatch('transportRail/setRailTransportation', {
                        'transType': data
                    });
                }
                else {
                    var cruise = getters['generalCruise'];
                    var cabinCat = getters['cabins/selectedCabinCategory'];
                    if (getters['pax/ages']) {
                        var railTransport = getters['transportRail/transport'];
                        var direction = 'RT';
                        if (railTransport.departure && !railTransport.arrival)
                            direction = 'O';
                        if (!railTransport.departure && railTransport.arrival)
                            direction = 'R';
                        var ageGroupNumbers = getters['pax/railGroups'];
                        var paxe = getters['pax/all'];
                        dispatch('transportRail/setRailTransportation', { 'cruiseId': cruise.id,
                            'transType': 'rail',
                            'priceModel': cruise.priceModel,
                            'cabinCat': cabinCat,
                            'adults': ageGroupNumbers.A + ageGroupNumbers.J,
                            'children': ageGroupNumbers.C,
                            'birthday0': paxe[0].birthday.value,
                            'birthday1': paxe.length > 1 ? paxe[1].birthday.value : '',
                            'birthday2': paxe.length > 2 ? paxe[2].birthday.value : '',
                            'birthday3': paxe.length > 3 ? paxe[3].birthday.value : '',
                            'birthday4': paxe.length > 4 ? paxe[4].birthday.value : '',
                            'departureDate': cruise.departure,
                            'direction': direction,
                            'transClass': getters['transportRail/transport'].selectedClass
                        });
                    }
                    else {
                        var ageGroupNumbers = getters['persons/asAgeGroups'];
                        var railTransport = getters['transportRail/transport'];
                        var direction = 'RT';
                        if (railTransport.departure && !railTransport.arrival)
                            direction = 'O';
                        if (!railTransport.departure && railTransport.arrival)
                            direction = 'R';
                        dispatch('transportRail/setRailTransportation', { 'cruiseId': cruise.id,
                            'transType': 'rail',
                            'priceModel': cruise.priceModel,
                            'cabinCat': cabinCat,
                            'adults': ageGroupNumbers.A + ageGroupNumbers.J,
                            'children': ageGroupNumbers.C,
                            'direction': direction,
                            'transClass': getters['transportRail/transport'].selectedClass
                        });
                    }
                    dispatch('transport/setTransportation', getters['transportRail/transportations']);
                }
            },
            'transport/setTransportation': function (_a, data) {
                var commit = _a.commit, dispatch = _a.dispatch, getters = _a.getters;
                if (getters['transport/getType'] === 'rail') {
                    dispatch('transportRail/setTransportation', data);
                }
                commit('transport/SET_TRANSPORTATION', data);
            },
            'transport/resetStore': function (_a) {
                var commit = _a.commit;
                commit('transport/RESET_STATE');
            }
        };
        // available mutations
        this.mutations = {
            'transport/RESET_STATE': function (state) {
                state.noneOptions = {
                    none: true
                };
                state.transportation = [];
                state.type = null;
                state.subType = null;
            },
            'transport/SET_SUB_TYPE': function (state, data) {
                state.subType = data;
            },
            'transport/SET_TYPE': function (state, data) {
                state.type = data;
            },
            'transport/SET_TRANSPORTATION': function (state, data) {
                state.transportation = data;
            },
            'transport/SET_NONE_OPTION': function (state, data) {
                state.noneOptions.none = data;
            }
        };
        this.state = new transport_state_1.State();
    }
    return Transport;
}());
exports.Transport = Transport;
//# sourceMappingURL=transport.js.map